import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../environments/environment'

@Injectable({
  providedIn: 'root',
})
export class Service {
  private http = inject(HttpClient);
  private apiUrl = environment.apiUrl;


  getLocations(): Observable<any[]> {
    return this.http.post<any[]>(this.apiUrl + '/lockers/manager/list',{});
  }
}
